import React from 'react';
import 'twin.macro';
import { StaticImage } from 'gatsby-plugin-image';

import Layout from '~components/Layout';
import SEO from '~components/SEO';
import Hero, { heroImgStyles } from '~components/Hero';
import Text, { ConstrainedText } from '~components/Text';
import Embed from '~components/Embed';
import IconCard from '~components/Card/IconCard';

// Icons
import Smile from '~components/Svg/Smile';
import ThumbsUp from '~components/Svg/ThumbsUp';
import Retweet from '~components/Svg/Retweet';
import CommentBubble from '~components/Svg/CommentBubble';
import Cursor from '~components/Svg/Cursor';
import Presentation from '~components/Svg/Presentation';

// Page Navigation
import PageNav from '~components/PageNav';
import CharliMaeCard from '~components/PageCard/CharliMaeCard';
import AcceleratingResearchCard from '~components/PageCard/AcceleratingResearchCard';

const StubPage: React.FC = () => {
  return (
    <Layout>
      <SEO title="Les enfants pour une guérison" desc="Description" />
      <Hero title="Les enfants pour une guérison">
        <StaticImage style={heroImgStyles} src="../../images/kids-for-a-cure.jpg" alt="" />
      </Hero>
      <div tw="container">
        <ConstrainedText>
        Organisé tous les deux ans, <i>Les enfants pour une guérison</i> est l’événement de défense d’intérêts le plus important de FRDJ Canada. Cet événement a pour but de s’assurer que les voix de la communauté des personnes atteintes du DT1 soient entendues à la table de décision du gouvernement. La campagne <i>Les enfants pour une guérison</i> rassemble nos incroyables jeunes défenseurs des quatre coins du pays pour qu’ils partagent leurs histoires personnelles sur ce que c’est que de vivre avec le DT1 et permettre aux représentants du gouvernement de mieux comprendre les défis quotidiens de cette maladie implacable, tout en soulignant l’importance d’accélérer les progrès vers la guérison.
        </ConstrainedText>
        <ConstrainedText>
        Pendant la semaine du 2 novembre, les délégués se sont joints à FRDJ pour sa journée de mobilisation semestrielle des enfants pour une guérison. En raison de la COVID-19, l’événement de 2020 s’est déroulé virtuellement, mais cela n’a pas empêché les enfants de tout le Canada de sensibiliser 167 députés et sénateurs aux défis quotidiens du DT1.
        </ConstrainedText>
        <Embed
          src="https://www.youtube-nocookie.com/embed/cXtu6m92HQ8"
          title="Kids for a Cure 2020: Thank You!"
        />
        <ConstrainedText>
        Nous avons simultanément apporté notre soutien à travers nos plateformes de médias sociaux, pour un total de 34 publications qui ont donné lieu à : 
        </ConstrainedText>
        <div tw="grid gap-6 my-12 sm:(grid-cols-2) md:(grid-cols-3)">
          <IconCard icon={<Smile tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">38,976 Impressions</Text>
          </IconCard>
          <IconCard icon={<ThumbsUp tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">199 J’aimes</Text>
          </IconCard>
          <IconCard icon={<Retweet tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">55 Retweets</Text>
          </IconCard>
          <IconCard icon={<CommentBubble tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">4 Réponses</Text>
          </IconCard>
          <IconCard icon={<Cursor tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">49 Clics d’hyperlien</Text>
          </IconCard>
          <IconCard icon={<Presentation tw="h-12 w-auto" />}>
            <Text tw="font-bold text-2xl">2.31 % Taux d’engagement total</Text>
          </IconCard>
        </div>
        <ConstrainedText>
        Tout au long de la semaine, nos jeunes ambassadeurs ont raconté leurs histoires personnelles sur ce que c’est que de vivre avec le DT1, sur l’importance d’améliorer l’accès aux nouveaux médicaments et dispositifs afin de mieux aider ceux qui vivent avec la maladie et sur la nécessité de financer davantage la recherche pour nous rapprocher des guérisons.
        </ConstrainedText>
        <PageNav previous={<CharliMaeCard />} next={<AcceleratingResearchCard />} />
      </div>
    </Layout>
  );
};

export default StubPage;
